import accounting from 'accounting'
import { externalUrl } from '../externalUrl'

const Filters = {
  install(Vue) {
    Vue.filter('nl2br', (value) => String(value).replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1<br>$2'))

    Vue.filter('externalUrl', (url) => externalUrl(url))

    Vue.filter('dollars', (value, precision = 2) => {
      return accounting.formatMoney(value, '$', precision)
    })

    Vue.filter('truncateWords', (value, maxWords, suffix = '...') => {
      if (!value) return ''
      const words = value.split(/\s+/).filter((word) => word.length > 0)
      const wordCount = words.length
      if (wordCount > maxWords) {
        return words.slice(0, maxWords).join(' ') + suffix
      }
      return value
    })
  },
}

export default Filters
